import React, { useContext } from 'react';
import { useParams } from 'react-router';

import styled from '@emotion/styled';

import useRehireDriver from '../../../../hooks/dashboard/driver-list/useRehireDriver';
import useGetDriverLookup from '../../../../hooks/dashboard/driver-lookup/useGetDriverLookup';
import {
  RehireDispatcherDataType,
  RehireDispatcherInitialValues,
  RehireDispatcherSchema,
} from '../../../../models/dashboard/driver-lookup/rehire-dispatcher';
import { DRIVER_LOOKUP_INFO } from '../../../../routes/routeConstants';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { CustomDatePicker } from '../../../FormCom/CustomDatePicker';
import CustomSelectField from '../../../FormCom/CustomSelectField';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TextInputField } from '../../../FormCom/FormField';
import NaijaPhoneInputField from '../../../FormCom/NaijaPhoneInputField';
import SingleDocumentUploadField from '../../../FormCom/SingleDocumentUploadField';
import Tooltip from '../../../Tooltip/Tooltip';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';
import PlainSuccessModal from '../../PlainSuccessModal';

interface RehireDispatcherModalProps {
  data: any;
}

const RehireDispatcherModal: React.FC<RehireDispatcherModalProps> = ({
  data,
}) => {
  const { ninNumber } = useParams();
  const modalContext = useContext(ModalContext);
  const { rehireDriver, loading } = useRehireDriver();
  const { getDriverLookup } = useGetDriverLookup();

  const onSubmit = (value: RehireDispatcherDataType) => {
    rehireDriver(
      { ...value, driverId: data?.driverId },
      () => {
        modalContext?.setShowModal(false);
        getDriverLookup(ninNumber, DRIVER_LOOKUP_INFO, () => {});
      },
      // null,
    );
  };

  const onCancelSubmit = () => {
    modalContext?.setShowModal(false);
  };

  const successActionFn = () => {
    modalContext?.setShowModal(false);
  };

  return (
    <Container>
      <ModalContainer
        label='Rehire Driver'
        successComponent={() => (
          <PlainSuccessModal
            successActionFn={successActionFn}
            description='This driver has successfully been hired.'
          />
        )}
        showSuccessComponent={modalContext?.showSuccessComponent}
      >
        <FormComponent
          initialValues={RehireDispatcherInitialValues}
          schema={RehireDispatcherSchema}
          onSubmit={onSubmit}
          className={'large-gap'}
        >
          <CustomDatePicker
            label='Set Start Date'
            name='startDate'
            id='startDate'
            placeholder='Set Start Date'
          />

          <NaijaPhoneInputField
            label='Phone number'
            name='phoneNumber'
            id='phoneNumber'
            type='text'
            placeholder='Phone number'
          />

          <SingleDocumentUploadField
            id='profilePicture'
            name='profilePicture'
            label='Upload Updated Professional Image of Driver'
            placeholder='Drag your file to start uploading'
            accept='.jpg,.jpeg,.png'
          />
          <CustomSelectField
            label={
              <div>
                Employment type:{' '}
                <Tooltip content='Gig workers are independent contractors who may provide services to multiple organizations. Exclusive staff are dedicated to your organization and are not expected to work for other employers.' />
              </div>
            }
            name='employmentType'
            id='employmentType'
            placeholder='Employment type'
            optionData={['Gig', ' Exclusive']}
          />

          <TextInputField
            label='House address'
            name='address'
            id='address'
            type='text'
            placeholder='House address'
          />

          <ButtonArea>
            <FormSubmitButton
              className='clear fill'
              onClick={onCancelSubmit}
              btnType='button'
            >
              Cancel
            </FormSubmitButton>
            <FormSubmitButton className='fill' loading={loading}>
              Rehire Driver
            </FormSubmitButton>
          </ButtonArea>
        </FormComponent>
      </ModalContainer>
    </Container>
  );
};

export default RehireDispatcherModal;

const Container = styled.div`
  flex-direction: column;
  display: flex;
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;
